import { Services } from '@sigma-frontend-libs/commons'
import { TaskTypes } from '@sigmasms/shared-types'

import render from './render'

export default {
  name: 'Title',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    to() {
      if (this.value.type === TaskTypes['payments:recurrent']) {
        if (this.value.data.recurrentPaymentId) {
          return {
            name: Services.payments,
            query: { recurrentPaymentId: this.value.data.recurrentPaymentId }
          }
        }
      }
    }
  },

  render
}
